import Avatar, { type AvatarSize, type AvatarVariant } from "./Avatar.tsx";
import styles from "./AvatarStack.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface AvatarStackProps<T> {
  items: T[];
  getInitials: (item: T) => string;
  getKey?: (item: T, index: number) => string | number;
  max?: number;
  size?: AvatarSize;
  variant?: AvatarVariant;
  overflowVariant?: AvatarVariant;
  className?: string;
}

export default function AvatarStack<T>({
  items,
  getInitials,
  getKey,
  max = 3,
  size,
  variant,
  overflowVariant = "blue",
  className,
}: AvatarStackProps<T>) {
  const visible = items.slice(0, max);
  const overflow = items.length - max;

  return (
    <div className={classnames(styles.stack, className)}>
      {visible.map((item, index) => (
        <Avatar
          key={getKey?.(item, index) ?? index}
          initials={getInitials(item)}
          size={size}
          variant={variant}
          className={styles.stacked}
        />
      ))}
      {overflow > 0 && (
        <Avatar
          initials={`+${overflow}`}
          size={size}
          variant={overflowVariant}
          className={styles.stacked}
        />
      )}
    </div>
  );
}
